import { UserInfoProvider } from '@/providers/UserInfoProvider';
import { UserInfoChecker } from '@/components/UserInfoChecker';
import { SentryUserSync } from './SentryUserSync';

export const App = () => (
  <UserInfoProvider>
    <SentryUserSync />
    <UserInfoChecker />
  </UserInfoProvider>
);
